import { useMutation } from "@tanstack/react-query";

import { API_URL } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { handleResponse } from "@/utils/errorResponseHandlers";

/**
 * Upload a file to OpenAI (multipart)
 */
export const useUploadFileToOpenAI = () => {
  const auth = useAuth();
  const userContext = useUser();
  const workspaceId = userContext?.activeWorkspaceId;

  return useMutation(
    async (params: {
      file: File;
      purpose?: string;
      expires_after?: { anchor: "created_at"; seconds: number };
    }) => {
      const formData = new FormData();
      formData.append("file", params.file);
      formData.append("workspace_id", String(workspaceId));
      if (params.purpose) {
        formData.append("purpose", params.purpose);
      }
      if (params.expires_after) {
        formData.append("expires_after", JSON.stringify(params.expires_after));
      }

      return fetch(`${API_URL}/api/dashboard/v2/vector-store/file/upload-to-openai`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${auth?.userToken ?? ""}`,
        },
        body: formData,
      }).then(handleResponse);
    },
  );
};
